import { PropsWithChildren } from 'react';
import { useSelectPackageGTM } from '../../../../hooks/gtm/useSelectPackageGTM';

export default function SelectPackageGtm(props: PropsWithChildren) {
  const { children } = props;

  useSelectPackageGTM();

  return <>{children}</>;
}
